import ConfirmDeleteDialog from "features/general/ConfirmDeleteDialog";
import { deleteFileEntry, FileEntry, useAppDispatch } from "model";
import { useState } from "react";
import FileEntryMoreMenu from "./FileEntryMoreMenu";
import UpdateFileEntry from "./UpdateFileEntry";
export default function UpdateAndDowloadFileEntryDialog({
  fileEntry,
  menuAnchor,
  closeMenu,
}: {
  fileEntry: FileEntry;
  menuAnchor: HTMLElement | null;
  closeMenu: () => void;
}) {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
  const dispatch = useAppDispatch();

  if (!fileEntry) {
    return null;
  }
  return (
    <>
      <FileEntryMoreMenu
        fileEntry={fileEntry}
        close={closeMenu}
        anchor={menuAnchor}
        setDialogOpen={setDialogOpen}
        setDeleteDialogOpen={setDeleteDialogOpen}
      />
      <UpdateFileEntry
        fileEntry={fileEntry}
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
      />
      <ConfirmDeleteDialog
        dialogOpen={deleteDialogOpen}
        deletedObjectDescription={fileEntry.fileName ?? ""}
        closeDialog={function (): void {
          setDeleteDialogOpen(false);
        }}
        onConfirmDelete={async function (): Promise<void> {
          await dispatch(deleteFileEntry(fileEntry));
          setDeleteDialogOpen(false);
        }}
      />
    </>
  );
}
